import React from 'react'
import Modal from 'react-bootstrap/Modal';

export default function WarningModalAddCartButtonRoman({
  pageLanguage,
  modals,
  modalHandleClose,
  addCartErr,
  t,
}) {
  return (
   <Modal
   backdrop="static"
   keyboard={false}
   dialogClassName={`addToCartErr bigSizeModal ${
     pageLanguage === "fa" ? "font_farsi" : "font_en"
   }`}
   show={modals["addToCartErr"] === undefined ? false : modals["addToCartErr"]}
   onHide={() => {
     modalHandleClose("addToCartErr");
   }}
 >
   <Modal.Header closeButton></Modal.Header>
   <Modal.Body>
   <div className="modal-header-grommet">
                  {pageLanguage === "fa" ? "برای ادامه نیاز است مراحل زیر را تکمیل کنید:" : "PLEASE COMPLETE THE FOLLOWING:"}
                  </div>
     <ul className={`addToCartErr_list_new ${ pageLanguage === "fa" ? "addToCartErr_list_font_farsi" : ""}`}>{addCartErr}</ul>
     <br />
     <span>{t("addToCartErr1")}</span>
     {/*<span>{t("addToCartErr2")}</span>*/}
     <span>{t("addToCartErr3")}</span>

     <br />
     <div className="text_center">
       <button className="btn btn-new-dark" onClick={() => modalHandleClose("addToCartErr")}>
         {t("OK")}
       </button>
     </div>
   </Modal.Body>
 </Modal>
  )
}
